<div class="api-error">
  <div class="vm-container cozy">
    <div class="vm-row">
      <div class="vm-col-xs-12 vm-col-md-12 vm-col-lg-12 vm-col-sm-12">
        <div class="main-content">
          <vo-icon icon="FalFaceFrown" size="2xl" />
          <div class="main-content__title">
            <h1>{{ errorContent.subtitle }}</h1>
          </div>
          <div class="main-content__info">
            <p>{{ errorContent.info }}</p>
          </div>
          <ng-content select="main-content__before-actions"></ng-content>
          <div class="main-content__actions">
            <div class="main-content__actions--single">
              <button
                vo-button
                (click)="goToNextPage()"
                [variant]="errorContent?.cta[0]?.buttonLevel"
                [layout]="'full-width'"
                [decoration]="'outline'"
                class="button-tertiary-outline"
              >
                {{ errorContent?.cta[0]?.label }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
